import { getMomentMinStr } from '../util';
import { convertDurationSecToStr } from '../util';

export const CHAT_BLOCK_LOG_ITEM_TYPE_BLOCK   = 1;
export const CHAT_BLOCK_LOG_ITEM_TYPE_UNBLOCK = 2;

export function getPlayerChatBlockPlannedDuration(block) {
  return block.ftime - block.ctime;
}

export function getPlayerChatBlockPlannedDurationStr(block) {
  const plannedDuration = getPlayerChatBlockPlannedDuration(block)
  return convertDurationSecToStr(plannedDuration);
}

export function getChatStatusStr(chatStatusInfo, nowSec) {
  if(chatStatusInfo.blocked && nowSec < chatStatusInfo.blockEnd) {
    const blockEndStr = getMomentMinStr(chatStatusInfo.blockEnd);
    return 'Chat is blocked unitl ' + blockEndStr + '.';
  }
  return 'Chat is available.';
}

export function isChatBlocked(chatStatusInfo, nowSec) {
  return chatStatusInfo.blocked && nowSec < chatStatusInfo.blockEnd;
}
